module.exports = "mutation DeleteUserVoucher($data:DeleteUserVoucherInput!){deleteUserVoucher(data:$data){success}}"